// Arbitrary pathogenicity scores in order to sort pathogenicity classifications from most
// pathogenic to most benigh
const sortScores = {
  B: 0,
  CA: 3,
  DA: 5,
  DR: 4,
  LB: 2,
  LP: 11,
  P: 13,
  PA: 8,
  PR: 7,
  RF: 6,
  VUS: 10,
  t1: 14,
  t2: 12,
  t3: 9,
  t4: 1,
};

export default sortScores;
